<template>
  <div class="w-full">
    <Modal v-model="props.isModal" containerClass="w-1/4">
      <template #container>
        <div class="w-full flex flex-col">
          <div class="p-4 border-b border-brand-gray-250 rounded flex justify-between items-center">
            <span class="text-xl font-semibold text-gray-500">{{ props.title }}</span>
            <faTimesIcon class="w-3 text-brand-gray-250" @click.prevent="close" />
          </div>
          <div class="w-full p-5 border-b">
            <span class="text-base font-bold text-gray-600">{{ props.label }}</span>
          </div>
          <div class="flex justify-between gap-2 w-full px-5 py-2">
            <div
              class="h-6 w-28 flex items-center justify-center gap-2 rounded-lg bg-white border border-primary text-primary cursor-pointer mt-2"
              @click.prevent="close"
            >
              close
            </div>
            <div
              class="h-6 w-28 flex items-center justify-center gap-2 rounded-lg bg-primary border-b-primary text-white cursor-pointer mt-2"
              @click.prevent="selected"
            >
              confirm
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import Modal from '@/components/Ui/Modal/index.vue'
import faTimesIcon from '@/assets/icons/faTimes.svg?component'

const emits = defineEmits(['select', 'close'])

const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  },
  label: {
    type: String,
    default: 'confirmationMsgFav'
  },
  servicesData: {
    servicesData: Array,
    default: () => []
  },
  title: {
    type: String,
    default: 'confirmation'
  }
})

const selected = () => {
  emits('select')
}

const close = () => {
  emits('close')
}
</script>

<style></style>
